import { render, staticRenderFns } from "./BeefInfo.vue?vue&type=template&id=03e00512&"
import script from "./BeefInfo.vue?vue&type=script&lang=js&"
export * from "./BeefInfo.vue?vue&type=script&lang=js&"
import style0 from "./BeefInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BeefInfo.vue"
export default component.exports